export default function notANumber(value = NaN, options = {}) {
  if (['', undefined, null, NaN].includes(value) && options.blank) {
    return false;
  }

  if (String(parseInt(value, 10)) !== String(value)) {
    return true;
  }

  return Number.isNaN(value);
}

notANumber.message = function message(value, options = {}) {
  return options.message || 'precisa ser um número';
};
